import { render, staticRenderFns } from "./test-portal-study-participants.vue?vue&type=template&id=cc47e138&"
import script from "./test-portal-study-participants.vue?vue&type=script&lang=js&"
export * from "./test-portal-study-participants.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "test-portal-study-participants.vue"
export default component.exports